import { takeLatest, put, call } from "redux-saga/effects";
import { handleApiError, isNotFoundError } from "@utils/errorHandler";

import {
  loadAllEnquiries,
  loadSingleEnquiry,
  setSingleEnquiryNotFound,
} from "./EnquiryList.slice";

import { loadAllEnquiriesAPI, loadSingleEnquiryAPI } from "./EnquiryList.api";

export const LOAD_ALL_ENQUIRIES = {
  LOADING: "Load all enquiries loading",
  SUCCESS: "Load all enquiries success",
  ERROR: "Load all enquiries error",
};

export const LOAD_SINGLE_ENQUIRY = {
  LOADING: "Load single enquiry loading",
  SUCCESS: "Load single enquiry success",
  ERROR: "Load single enquiry error",
};

function* loadAllEnquiriesWorker(action) {
  const { payload } = action;

  try {
    const data = yield call(loadAllEnquiriesAPI, payload);
    yield put(loadAllEnquiries(data));
  } catch (error) {
    handleApiError(error);
    yield put({ type: LOAD_ALL_ENQUIRIES.ERROR, error });
  }
}

function* loadSingleEnquirySagaWorker(action) {
  const { payload } = action;

  try {
    const data = yield call(loadSingleEnquiryAPI, payload);
    yield put(loadSingleEnquiry(data));
  } catch (error) {
    if (isNotFoundError(error)) {
      yield put(setSingleEnquiryNotFound(true));
      return;
    }
    handleApiError(error);
    yield put({ type: LOAD_SINGLE_ENQUIRY.ERROR, error });
  }
}

export function* loadAllEnquiriesSaga() {
  yield takeLatest(LOAD_ALL_ENQUIRIES.LOADING, loadAllEnquiriesWorker);
}

export function* loadSingleEnquirySaga() {
  yield takeLatest(LOAD_SINGLE_ENQUIRY.LOADING, loadSingleEnquirySagaWorker);
}
